import React from "react";
import {
  overviewItem,
  itemLabel,
  itemValue,
  policyDetails,
} from "../Shared/Styles";

export default function PolicyDetails(props) {

  if (props.policyDetails !== undefined) {
    return (
      <div style={policyDetails}>
        <div style={overviewItem}>
          <span style={itemLabel}>Policy Number</span>
          <span style={itemValue}>{props.policyDetails[0].policyNumber}</span>
        </div>

        <div style={overviewItem}>
          <span style={itemLabel}>Status</span>
          <span style={itemValue}>{props.policyDetails[0].status}</span>
        </div>

        <div style={overviewItem}>
          <div style={itemLabel}>Adviser Name</div>
          <div style={itemValue}>{props.policyDetails[0].adviserName}</div>
        </div>

        <div style={overviewItem}>
          <span style={itemLabel}>Adviser Number</span>
          <span style={itemValue}>{props.policyDetails[0].adviserNumber}</span>
        </div>
      </div>
    );
  }
}
